module.exports = __webpack_public_path__ + "img/needle.13ba8acd.svg";